package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_age_gate_body
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_age_gate_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_age_gate_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_age_gate_note
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_age_gate_title
import org.jetbrains.compose.resources.stringResource

/**
 * 18+ self-confirmation bottom sheet — Stitch `0365dbc1309046d5a572063dcf820db2`. Shown only when
 * the adult tier is Remote-Config enabled AND the user has not yet opted in
 * (`docs/HIDDEN_GEMS_PLAN.md` §3). Confirming stores `users/{uid}.adultContentOptIn` (+ the
 * device-local pref for guests).
 */
@Composable
internal fun AgeGateSheet(
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AppBottomSheet(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = AppTheme.spacing.lg)
                .padding(bottom = AppTheme.spacing.lg),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Gold "18" badge (Stitch): saffron circle + the numeral rendered as an icon glyph.
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.categoryBadge)
                    .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.pill),
                contentAlignment = Alignment.Center,
            ) {
                AppIcon(
                    name = "explicit",
                    size = AppTheme.sizes.iconLg,
                    tint = AppTheme.colors.onSecondaryContainer,
                )
            }
            Text(
                text = stringResource(Res.string.gems_age_gate_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(top = AppTheme.spacing.lg),
            )
            Text(
                text = stringResource(Res.string.gems_age_gate_body),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(top = AppTheme.spacing.sm),
            )
            AppButton(
                text = stringResource(Res.string.gems_age_gate_confirm),
                onClick = onConfirm,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = AppTheme.spacing.xl),
            )
            AppButton(
                text = stringResource(Res.string.gems_age_gate_cancel),
                onClick = onDismiss,
                variant = AppButtonVariant.Secondary,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = AppTheme.spacing.sm),
            )
            Text(
                text = stringResource(Res.string.gems_age_gate_note),
                style = AppTheme.typography.labelSm,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(top = AppTheme.spacing.md),
            )
        }
    }
}
